export default {
    src: import.meta.ROLLUP_FILE_URL_U2YZxvNlcnuoWcGKwa9Wsw,
    srcSet: `${import.meta.ROLLUP_FILE_URL_U2YZxvNlcnuoWcGKwa9Wsw} 300w, ${import.meta.ROLLUP_FILE_URL_cLZLOsSELI_GmwKcVOKKRw} 600w`,
    imageSet: `image-set(url("${import.meta.ROLLUP_FILE_URL_U2YZxvNlcnuoWcGKwa9Wsw}") 1x, url("${import.meta.ROLLUP_FILE_URL_cLZLOsSELI_GmwKcVOKKRw}") 2x)`,
    width: 300,
    height: 273,
};